import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const REGIONS = [
  ["Auckland Central", "North Shore", "West Auckland", "South Auckland"],
  ["Counties Manukau", "Manukau", "Otahuhu", "Mangere"],
  ["Hamilton", "Tauranga", "Rotorua", "Hawke's Bay"],
  ["Wellington", "Hutt Valley", "Christchurch", "Dunedin"],
];

export default function ServingTeams() {
  return (
    <section
      id="serving"
      data-testid="serving-section"
      className="py-20 md:py-28 border-y border-zinc-900 bg-zinc-950"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.3em] text-teal-400 font-semibold">
            Local SEO · NZ-wide reach
          </p>
          <h2 className="mt-3 font-display uppercase text-3xl md:text-5xl tracking-tight leading-[0.95]">
            Serving teams across <br />
            <span className="text-teal-400">Auckland &amp; NZ</span>
          </h2>
          <p className="mt-5 text-zinc-400 leading-relaxed max-w-md">
            Based in Auckland, Tribal Designz designs and ships custom
            uniforms across New Zealand every week. From{" "}
            <Link to="/custom-rugby-uniforms-nz" className="text-teal-400 hover:underline">
              rugby clubs
            </Link>{" "}
            in South Auckland to{" "}
            <Link to="/custom-basketball-jerseys-nz" className="text-teal-400 hover:underline">
              basketball squads
            </Link>{" "}
            in Wellington — we deliver coast to coast.
          </p>

          <div className="mt-8 flex items-center gap-3 text-zinc-300">
            <span className="w-10 h-10 bg-zinc-900 border border-zinc-800 grid place-items-center">
              <MapPin size={18} className="text-teal-400" />
            </span>
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                Studio location
              </div>
              <div className="font-display uppercase">Auckland · Aotearoa NZ</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-3 mb-8">
            {REGIONS.flat().map((r) => (
              <div key={r} className="flex items-center gap-2 text-sm text-zinc-300">
                <span className="w-1 h-1 bg-teal-400" />
                {r}
              </div>
            ))}
          </div>

          <div className="aspect-[16/10] border border-zinc-800 overflow-hidden">
            <iframe
              title="Tribal Designz — Auckland NZ"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d206708.6985283867!2d174.6347293!3d-36.8484597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d0d47fb5a9ce6fb%3A0x500ef6143a29917!2sAuckland!5e0!3m2!1sen!2snz!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0, filter: "grayscale(0.4) invert(0.92) hue-rotate(180deg)" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="auckland-map"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
